/** Corner radius shared by cards and tiles. */
export const CARD_RADIUS = 12;

/** Corner radius of the page header and welcome banner. */
export const HEADER_RADIUS = 14;

/** The faint shadow that gives a card's outline its definition. */
export const CARD_SHADOW = '0 1px 3px rgba(0,0,0,0.04)';
